import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Paper,
  InputLabel,
  FormControl,
  Select,
  MenuItem
} from '@mui/material';

const EntityReferralStatistics = () => {
  const payoutHistory = [
    {
      month: "February 2026",
      referrals: 8,
      amount: "$8.00",
      paid: "$8.00",
      pending: "$0.00",
      status: "Completed",
    },
    {
      month: "January 2026",
      referrals: 6,
      amount: "$6.00",
      paid: "$5.00",
      pending: "$1.00",
      status: "Pending",
    },
  ];

  const cardStyle = {
    backgroundColor: '#f8f9fa',
    border: '1px solid #e9ecef',
    width:"100%",
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
      borderColor: '#214F7D',
    }
  };

  const sectionStyle = {
    backgroundColor: '#fff',
    border: '1px solid #e9ecef',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
  };

  const formRowStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    '& label': {
      width: '200px',
      fontWeight: 500,
      color: '#495057',
    },
    '& span': {
      padding: '8px 12px',
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '6px',
      minWidth: '150px',
    }
  };

  const inputStyle = {
    width: '300px',
    padding: '8px 12px',
    border: '1px solid #dee2e6',
    borderRadius: '6px',
    fontSize: '14px',
    '&:focus': {
      outline: 'none',
      borderColor: '#214F7D',
      boxShadow: '0 0 0 2px rgba(33, 79, 125, 0.2)',
    }
  };

  const saveButtonStyle = {
    backgroundColor: '#214F7D',
    color: 'white',
    padding: '10px 24px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#1a3f63',
      transform: 'translateY(-1px)',
    }
  };

  const tableHeaderStyle = {
    backgroundColor: '#f8f9fa',
    '& th': {
      fontWeight: 600,
      color: '#214F7D',
      fontSize: '14px',
      padding: '12px',
      borderBottom: '2px solid #dee2e6',
    }
  };

  const tableCellStyle = {
    padding: '12px',
    borderBottom: '1px solid #dee2e6',
    fontSize: '14px',
  };

  const statusCompleteStyle = {
    backgroundColor: '#d4edda',
    color: '#155724',
    padding: '4px 10px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 600,
  };

  const statusPendingStyle = {
    backgroundColor: '#fff3cd',
    color: '#856404',
    padding: '4px 10px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 600,
  };

  return (
    <Box sx={{ padding: '24px', fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      
      {/* Top Cards */}
      <Grid container spacing={3} sx={{ marginBottom: '32px' }}>
        <Grid item xs={12} md={6}>
          <Card sx={cardStyle}>
            <CardContent>
              <Typography 
                variant="body2" 
                sx={{ 
                  margin: '0 0 12px 0',
                  fontSize: '14px',
                  color: '#666',
                  fontWeight: 500,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}
              >
                Total Referrals (Lifetime)
              </Typography>
              <Typography 
                variant="h3" 
                sx={{ 
                  margin: 0,
                  fontSize: '32px',
                  fontWeight: 700,
                  color: '#214F7D'
                }}
              >
                30
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={cardStyle}>
            <CardContent>
              <Typography 
                variant="body2" 
                sx={{ 
                  margin: '0 0 12px 0',
                  fontSize: '14px',
                  color: '#666',
                  fontWeight: 500,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}
              >
                Total Referral Earnings
              </Typography>
              <Typography 
                variant="h3" 
                sx={{ 
                  margin: 0,
                  fontSize: '32px',
                  fontWeight: 700,
                  color: '#214F7D'
                }}
              >
                $30
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Current Month Section */}
      <Box sx={sectionStyle}>
        <Typography 
          variant="h5" 
          sx={{ 
            color: '#214F7D',
            margin: '0 0 20px 0',
            fontSize: '20px',
            fontWeight: 600
          }}
        >
          Current Month: March 2026
        </Typography>

        <Box sx={formRowStyle}>
          <label>Current Month Referrals:</label>
          <span>5</span>
        </Box>

        {/* Amounts and Payment Status Row */}
        <Box sx={{ display: 'flex', gap: 2, marginBottom: '16px', alignItems: 'center', flexWrap: 'nowrap' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: '250px', }}>
            <label style={{ width: '140px', fontWeight: 500, color: '#495057', whiteSpace: 'nowrap', marginRight: '16px' }}>Paid Referral Amount:</label>
            <TextField
              value="$0.00"
              readOnly
              sx={{
                width: '100px',
                '& .MuiInputBase-input': {
                  padding: '8px 12px',
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #dee2e6',
                  borderRadius: '6px',
                  fontSize: '14px',
                },
                '& .MuiInputBase-input.Mui-disabled': {
                  backgroundColor: '#e9ecef',
                  color: '#6c757d',
                }
              }}
            />
          </Box>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: '200px' }}>
            <label style={{ width: '110px', fontWeight: 500, color: '#495057', whiteSpace: 'nowrap', marginRight: '16px' }}>Pending Amount:</label>
            <span style={{ 
              padding: '8px 12px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #dee2e6',
              borderRadius: '6px',
              minWidth: '80px',
              color: '#dc3545',
              fontWeight: 600
            }}>
              $5.00
            </span>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: '200px' }}>
            <label style={{ width: '110px', fontWeight: 500, color: '#495057', whiteSpace: 'nowrap', marginRight: '8px' }}>Payment Status:</label>
            <FormControl sx={{ width: '120px' }}>
              <Select
                value="Pending"
                displayEmpty
                sx={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #dee2e6',
                  borderRadius: '6px',
                  fontSize: '14px',
                  '& .MuiSelect-select': {
                    padding: '8px 12px',
                  },
                  '&:hover': {
                    borderColor: '#214F7D',
                  },
                  '&.Mui-focused': {
                    borderColor: '#214F7D',
                    boxShadow: '0 0 0 2px rgba(33, 79, 125, 0.2)',
                  }
                }}
              >
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Completed">Completed</MenuItem>
                <MenuItem value="Processing">Processing</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Box sx={formRowStyle}>
          <label>Remark (Transaction ID):</label>
          <TextField
            fullWidth={false}
            placeholder="Enter transaction ID"
            sx={{
              width: '300px',
              '& .MuiInputBase-input': inputStyle
            }}
          />
        </Box>

        <Box sx={formRowStyle}>
          <label>Attachment:</label>
          <input 
            type="file" 
            style={{
              padding: '8px',
              border: '1px solid #dee2e6',
              borderRadius: '6px',
              backgroundColor: 'white',
              fontSize: '14px'
            }}
          />
        </Box>

        <Button 
          variant="contained" 
          sx={saveButtonStyle}
        >
          Save
        </Button>
      </Box>

      {/* Payout History */}
      <Box sx={sectionStyle}>
        <Typography 
          variant="h5" 
          sx={{ 
            color: '#214F7D',
            margin: '0 0 20px 0',
            fontSize: '20px',
            fontWeight: 600
          }}
        >
          Payout History
        </Typography>

        <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid #dee2e6' }}>
          <Table>
            <TableHead sx={tableHeaderStyle}>
              <TableRow>
                <TableCell>Month</TableCell>
                <TableCell>Referrals</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Paid</TableCell>
                <TableCell>Pending</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payoutHistory.map((item, index) => (
                <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#f8f9fa' } }}>
                  <TableCell sx={tableCellStyle}>{item.month}</TableCell>
                  <TableCell sx={tableCellStyle}>{item.referrals}</TableCell>
                  <TableCell sx={tableCellStyle}>{item.amount}</TableCell>
                  <TableCell sx={tableCellStyle}>{item.paid}</TableCell>
                  <TableCell sx={tableCellStyle}>{item.pending}</TableCell>
                  <TableCell sx={tableCellStyle}>
                    <span style={item.status === "Completed" ? statusCompleteStyle : statusPendingStyle}>
                      {item.status}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default EntityReferralStatistics;
 